<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav>
        <h4 class="mb-0">Отчёты</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-button id="filter-button" size="sm" variant="warning" v-b-toggle.collapse-filters>
          <font-awesome-icon icon="filter" />
        </b-button>
        <b-tooltip target="filter-button" triggers="hover" variant="warning" noninteractive>
          Фильтры
        </b-tooltip>
      </b-navbar-nav>
    </b-navbar>

    <b-collapse id="collapse-filters" class="mt-0" visible>
      <b-card>
        <b-row>
          <b-col class="col-6 col-lg-2">
            <b-form-input class="mb-2 mr-sm-2 mb-sm-0" size="sm" id="input_startDate" type="date" v-model.date="startDate"></b-form-input>
          </b-col>
          <b-col class="col-6 col-lg-2">
            <b-form-input class="mb-2 mr-sm-2 mb-sm-0" size="sm" id="input_endDate" type="date" v-model.date="endDate"></b-form-input>
          </b-col>
        </b-row>
      </b-card>
    </b-collapse>

    <div class="m-3">
      <b-row>
        <b-col cols="6">
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center" >
              Пользователи
              <b-button variant="success" @click="onUsers">Скачать</b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center" >
              Заказчики
              <b-button variant="success" @click="onCustomers">Скачать</b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center" >
              Объекты
              <b-button variant="success" @click="onLocations">Скачать</b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center" >
              Исполнители
              <b-button variant="success" @click="onWorkers">Скачать</b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center" >
              Заявки
              <b-button variant="success" @click="onTasks">Скачать</b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center" >
              Исполнители в заявке
              <b-button variant="success" @click="onTaskWorkers">Скачать</b-button>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import reports from "../../network/reports";
  import dateFormatter from "../../utilites/dateFormatter";
  import helpers from "../../utilites/helpers";

export default {
  name: "Reports",
  mixins: [
    reports,
    dateFormatter, helpers
  ],
  data() {
    return {
      startDate: this.formatDate(new Date()),
      endDate: this.formatDate(new Date()),
    }
  },
  methods: {
    getFileName(name, ext) {
      const start = this.formatDateFile(this.startDate);
      const end = this.formatDateFile(this.endDate);
      return `${name}_${start}-${end}_data${ext}`
    },
    validatePeriod() {
      if (!this.isDateValid(this.startDate) || !this.isDateValid(this.endDate)) {
        this.$bvToast.toast('Укажите период', {
          title: 'Ошибка!',
          variant: 'danger',
          autoHideDelay: 3000,
          solid: true
        });

        return false;
      }

      return true;
    },
    async onUsers() {
      if (!this.validatePeriod()) { return; }
      const type = "users";
      const ext = ".xlsx"
      const fileName = this.getFileName(type, ext);
      await this.downloadFile(type, fileName);
    },
    async onCustomers() {
      if (!this.validatePeriod()) { return; }
      const type = "customers";
      const ext = ".xlsx"
      const fileName = this.getFileName(type, ext);
      await this.downloadFile(type, fileName);
    },
    onLocations: async function () {
      if (!this.validatePeriod()) { return; }
      const type = "locations";
      const ext = ".xlsx"
      const fileName = this.getFileName(type, ext);
      await this.downloadFile(type, fileName);
    },
    async onWorkers() {
      if (!this.validatePeriod()) { return; }
      const type = "workers";
      const ext = ".xlsx"
      const fileName = this.getFileName(type, ext);
      await this.downloadFile(type, fileName);
    },
    async onTasks() {
      if (!this.validatePeriod()) { return; }
      const type = "tasks";
      const ext = ".xlsx"
      const fileName = this.getFileName(type, ext);
      await this.downloadFile(type, fileName);
    },
    async onTaskWorkers() {
      if (!this.validatePeriod()) { return; }
      const type = "task_workers";
      const ext = ".xlsx"
      const fileName = this.getFileName(type, ext);
      await this.downloadFile(type, fileName);
    },
    async downloadFile(type, fileName) {
      const data = {
        start: this.getDateToServer(this.startDate).toISOString(),
        end: this.getDateToServer(this.endDate).toISOString(),
        type: type
      }

      const result = await this.getSummaryFile(data);

      if (!result.data) return;

      this.handleFileDownload(result.data, fileName);
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Reports/Reports.vue